const moduleName = 'uncustomui'

export default [
  {
    path: '/uncustomui-example',
    name: 'ExampleView',
    component: () => import('../../lib/' + moduleName + '/example/ExampleView.vue')
  }
]
